import React, { useState } from "react";
import { apiCall } from "../main/ApiCall";
import "../css/others/Popup.css";
import ToastPopup from "./ToastPopup";
import { EditFunctionPopupProps, createToastMessage, ToastMessage } from "../interFaces/interfaces";
import { validateForm, nameValidationRules, emailValidationRules } from "../Reusablecomponents/Validation";
const updatedBy = localStorage.getItem("email");
const formatDateTimeForBackend = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day} 00:00:00`;
};
const EditFunctionPopup: React.FC<EditFunctionPopupProps> = ({ functionData, onClose, onUpdateSuccess }) => {
    const [updatedFunction, setUpdatedFunction] = useState({ ...functionData });
    const [message, setMessage] = useState<ToastMessage | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (["functionHeadName", "functionSpocName"].includes(name)) {
            if (value.length > 60) {
                setMessage(createToastMessage("Maximum 60 characters allowed", "warning", 3000));
                return;
            }
            if (containsSpecialChars(value)) {
                setMessage(createToastMessage(`Special characters are not allowed - ${restrictedChars}`, "warning", 3000));
                return;
            }
        }
        if (["functionHeadEmail", "functionSpocEmail"].includes(name)) {
            if (containsSpecialChars(value.replace("@", "").replace(".", ""))) {
                setMessage(createToastMessage("Invalid characters in email", "error", 3000));
                return;
            }
            if (value && !isValidEmailFormat(value)) {
                setMessage(createToastMessage("Please enter a valid email address", "warning", 3000));
            }
        }
        setUpdatedFunction((prev: any) => ({
            ...prev, [name]: value
        }));
    };
    const handleSave = async () => {
        setIsLoading(true);
        const { isValid, errors } = validateForm({
            functionHeadName: { value: updatedFunction.functionHeadName, rules: [...nameValidationRules, { maxLength: 60 }], name: "Function Head Name" }, functionHeadEmail: { value: updatedFunction.functionHeadEmail, rules: emailValidationRules, name: "Function Head Email" }, functionSpocName: { value: updatedFunction.functionSpocName, rules: [...nameValidationRules, { maxLength: 60 }], name: "Function SPOC Name" }, functionSpocEmail: { value: updatedFunction.functionSpocEmail, rules: emailValidationRules, name: "Function SPOC Email" }
        });
        if (!isValid) {
            setFieldErrors(errors);
            const firstError = Object.values(errors)[0];
            setMessage(createToastMessage(firstError, "warning", 3000));
            setIsLoading(false);
            return;
        }
        try {
            const updatedData = { ...updatedFunction, updatedBy, updateDate: formatDateTimeForBackend(new Date()) };
            await apiCall("put", `/api/functions/${functionData.functionId}`, updatedData);
            setMessage(createToastMessage("Function updated successfully!", "success", 3000));
            if (onUpdateSuccess) onUpdateSuccess();
            setTimeout(() => onClose(), 3000);
        } catch (error: any) {
            const errorMessage = error?.response?.data?.message || "Failed to update function";
            setMessage(createToastMessage(errorMessage, "error", 3000));
        } finally {
            setIsLoading(false);
        }
    };
    const restrictedChars = /[\\:*?"<>|/]/;
    const containsSpecialChars = (str: string) => {
        return restrictedChars.test(str);
    };
    const isValidEmailFormat = (email: string) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    return (
        <div className="popup-overlay">
            <div className="modal-content1">
                <h3>Edit Function</h3>
                <div className="modal-content-list">
                    <label>Function Head Name
                        <input type="text" name="functionHeadName" value={updatedFunction.functionHeadName || ""} onChange={handleChange} className={fieldErrors.functionHeadName ? "error" : ""} />
                    </label>
                    <label>Function Head Email
                        <input type="email" name="functionHeadEmail" value={updatedFunction.functionHeadEmail || ""} onChange={handleChange} className={fieldErrors.functionHeadEmail ? "error" : ""} />
                    </label>
                    <label>Function SPOC Name
                        <input type="text" name="functionSpocName" value={updatedFunction.functionSpocName || ""} onChange={handleChange} className={fieldErrors.functionSpocName ? "error" : ""} />
                    </label>
                    <label>Function SPOC Email
                        <input type="email" name="functionSpocEmail" value={updatedFunction.functionSpocEmail || ""} onChange={handleChange} className={fieldErrors.functionSpocEmail ? "error" : ""} />
                    </label>
                </div>
                <div className="buttons">
                    <button className="cancelbutton" onClick={onClose}>Cancel</button>
                    <button className="savebutton" onClick={handleSave} disabled={isLoading}>{isLoading ? "Saving..." : "Save"} </button>
                </div>
            </div>
            {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
        </div>
    );
};
export default EditFunctionPopup;